import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ResultadosService } from 'app/main/pagina/resultados/resultados.service';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_surveyStatusV2 } from 'app/idiomas/i18n/survey-status-v2/survey-status-v2.lang';
import { lang_avances } from 'app/idiomas/i18n/avances/avances.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_toolbar } from 'app/idiomas/i18n/toolbar/toolbar.lang';
import { lang_webProfile } from 'app/idiomas/i18n/webProfile/webProfile.lang';
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { WebCompProfileService } from 'app/main/pagina/web-comp-profile/web-comp-profile.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DATOS_API } from 'app/auth/auth.datos';

@Component({
  selector: 'app-survey-status-v2',
  templateUrl: './survey-status-v2.component.html',
  styleUrls: ['./survey-status-v2.component.scss'],
  animations   : fuseAnimations
})
export class SurveyStatusV2Component implements OnInit {

  menuAbierto = false;
  detallesAbierto = false;
  nombreEmpresa: string;
  idEmpresa: any;

  statusMenu: Subject<any> = new Subject<any>();
  productoElegido: Subject<any> = new Subject<any>();
  infoDetalleProducto: Subject<any> = new Subject<any>();
  cargaPrevio: Subject<any> = new Subject<any>();
  brokerEmpresa: Subject<any> = new Subject<any>();
  iframe:boolean=false;
  urlTableau="";
  rutaPagina:string;
  btnCopyUrlIframe:boolean;
  btnCopyHelpIframe:boolean;
  idiomaActual:string;
  idiomaVideo:string;
  tipoIframe:string;
  textWarning="";
  urlCorrect:boolean;
  urlSafe: any;

  constructor(
    private location: Location,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private servTableau: ResultadosService,
    private translateSrv: TranslateService,
    private activatedRoute : ActivatedRoute,
    private wcp: WebCompProfileService,
    public sanitizer: DomSanitizer
  ) {
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_surveyStatusV2.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_avances.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_cierre.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_toolbar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_webProfile.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.translateSrv.onLangChange.subscribe(() => {
      if (localStorage.getItem('urlResulIframe')) {
        let datos={};
        if (localStorage.getItem('tipoIframe')=="resul") {
        datos={
            status:true,
            tipoIframe:'resul',
          }
        }else{
          datos={
            status:true,
            tipoIframe:'resulV2',
          }
        }
        this.mostrarIframe(datos);
        this.rutaPagina=localStorage.getItem('urlResulIframe');
        this.nombreEmpresa=localStorage.getItem('nombreEmpresa');
        this.btnCopyUrlIframe=true;
        this.btnCopyHelpIframe=false;
      }else if (localStorage.getItem('urlWCPIframe')) {
        let datos={
          status:true,
          tipoIframe:'wpc',
        }
        this.mostrarIframe(datos);
        this.rutaPagina=localStorage.getItem('urlWCPIframe');
        this.nombreEmpresa=localStorage.getItem('nombreEmpresa');
        this.btnCopyUrlIframe=false;
        this.btnCopyHelpIframe=true;
        console.log('entro urlWCPIframe');
      }else{
        this.btnCopyUrlIframe=false;
        this.btnCopyHelpIframe=false;
        console.log('No hace nada de nada');
        this.rutaPagina="";

      }
      this.idiomaActual = this.translateSrv.currentLang;
      console.log('idioma Actual',this.idiomaActual);
      switch (this.idiomaActual) {
        case 'es':
          this.idiomaVideo='PERFILWEB6';
          break;
        default:
        this.idiomaVideo='WebCompanyProfile';
          break;
      }

    });

    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    });
  }

  ngOnInit() {
    if (localStorage.getItem('urlResulIframe')) {
      console.log(localStorage.getItem('tipoIframe'));
      this.urlTableau=localStorage.getItem('urlResulIframe');
      this.rutaPagina=localStorage.getItem('urlResulIframe');
      this.nombreEmpresa=localStorage.getItem('nombreEmpresa');
      this.iframe=true;
      this.btnCopyUrlIframe=true;
      this.btnCopyHelpIframe=false;
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlTableau);
      if (localStorage.getItem('tipoIframe')=="resul") {
        this.tipoIframe="resul";
        let productosModal=[40,41];
        if (localStorage.getItem("instituto_Empresa")=="1" && localStorage.getItem('modalAvisoIframe')=="true" && productosModal.includes(parseInt(localStorage.getItem("tipoIdProducto"))) && localStorage.getItem("fechaProducto")=="2023") {
            Swal.fire({
              icon: 'info',
              title: localStorage.getItem('modalMessageAvisoIframe'),
              width: 600,
              confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
            });
        }
      }else{
        this.tipoIframe="resulV2";
      }

    }else if (localStorage.getItem('urlWCPIframe')) {
      this.urlTableau=localStorage.getItem('urlWCPIframe');
      this.iframe=true;
      this.rutaPagina=localStorage.getItem('urlWCPIframe');
      this.nombreEmpresa=localStorage.getItem('nombreEmpresa');
      this.btnCopyUrlIframe=false;
      this.btnCopyHelpIframe=true;
      this.tipoIframe="wpc";
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlTableau);
      this.urlCorrect=true;
    }else{
      this.urlTableau="";
      this.iframe=false;
      this.rutaPagina="";
      this.btnCopyUrlIframe=false;
      this.btnCopyHelpIframe=false;
    }

    this.idiomaActual = this.translateSrv.currentLang;
    console.log('idioma Actual',this.idiomaActual);
    switch (this.idiomaActual) {
      case 'es':
        this.idiomaVideo='PERFILWEB6';
        break;
      default:
      this.idiomaVideo='WebCompanyProfile';
        break;
    }
  }

  regresar(){
    this.location.back();
  }


  mostrarIframe(datos:any){
    console.log("datos",datos);
    this.tipoIframe=datos.tipoIframe
    let instito= localStorage.getItem('instituto_Empresa');
    let tipoProducto= localStorage.getItem('tipoIdProducto');
    let token= localStorage.getItem('surveyToken');
    let user= localStorage.getItem('user_padre');
    let flag= localStorage.getItem('versionResultSuccesGo');
    let claveIdioma =this.translateSrv.currentLang;
    console.log("entro perro",claveIdioma);
    let claveIdiomaDato:any;
    switch (claveIdioma) {
      case 'es':
      claveIdiomaDato='ES';
      break;
      case 'tr':
      claveIdiomaDato='TR';
      break;
      case 'en':
      claveIdiomaDato='EN';
      break;
      case 'zh1':
      claveIdiomaDato='ZH1';
      break;
      case 'zh2':
      claveIdiomaDato='ZH2';
      break;
      case 'pt':
      claveIdiomaDato='PT';
      break;
      case 'de':
      claveIdiomaDato='DE';
      break;
      case 'nl':
      claveIdiomaDato='NL';
      break;

      default:
      break;
    }

    console.log('idEmpresa',this.idEmpresa);
    if (datos.tipoIframe=="resul" || datos.tipoIframe=="resulV2") {
      let versionResult= datos.tipoIframe=='resul'?1:2;
      localStorage.setItem('tipoIframe',this.tipoIframe);
      this.btnCopyUrlIframe=true;
      this.btnCopyHelpIframe=false;
      this.servTableau.getURLSuccessGoV4(this.idEmpresa,token, tipoProducto, instito, claveIdiomaDato, user,flag,versionResult).subscribe( (respuestaUrl:any) => {
        console.log(respuestaUrl);
        if(respuestaUrl.success == true){

          /// concatenar parametro id dominio
          const paramsDominios = [
            // { dominio: 'culturalgo.com', id: '01' },
            { dominio: 'localhost', id: '02' },
            { dominio: 'app04.culturalgo.com', id: '02' }
          ];
          const [dominio] = (window.location.href).split('#');
          const urlSplit = respuestaUrl.urlSuccesGo.split('&');
          let domCoincidente: any = { dominio: 'culturalgo.com', id: '01' };
          paramsDominios.every(domEsp => {
            if(dominio.includes(domEsp.dominio)){
              domCoincidente = domEsp;
              return false;
            }
            return true;
          });
          urlSplit.push(`domain_id=${domCoincidente.id}`);
          let urlFinal = "";
          urlSplit.map(x => urlFinal = (`${urlFinal}${x}&`).trim());
          urlFinal = urlFinal.slice(0, -1);

          this.urlTableau = respuestaUrl.urlSuccesGo;
          // this.urlTableau = urlFinal;
          this.rutaPagina = respuestaUrl.urlSuccesGo;
          // this.rutaPagina = urlFinal;

          localStorage.setItem('urlResulIframe',this.urlTableau);
          localStorage.setItem('modalAvisoIframe',respuestaUrl.modalAviso);
          localStorage.setItem('modalMessageAvisoIframe',respuestaUrl.message);
          this.iframe = true;
          let productosModal=[40,41];
          Swal.close();
          if (datos.tipoIframe=="resul" && respuestaUrl.modalAviso== true && localStorage.getItem("instituto_Empresa")=="1" && productosModal.includes(parseInt(localStorage.getItem("tipoIdProducto"))) && localStorage.getItem("fechaProducto")=="2023" ){
            Swal.fire({
              icon: 'info',
              title: respuestaUrl.message,
              width: 600,
              confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
            });
          }

          this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlTableau);

          setTimeout(() => {
            // console.log("se dispara form alv");
            console.log("URL TABLEAU: ",this.urlTableau);

            // $('#RecDatos').submit();
            var scrollElem= document.querySelector('#Principal');
            scrollElem.scrollIntoView();
          },1000);
        }else{
          Swal.close();
        }
      });
    }else if (datos.tipoIframe=='wpc') {
      // console.log("Si jalo este visne ");

      this.btnCopyUrlIframe=false;
      this.btnCopyHelpIframe=true;
      this.wcp.getUrlWebComProfile(localStorage.getItem('companyID'),claveIdioma).subscribe( (respuestaUrl:any) => {
        console.log('respuestaUrl',respuestaUrl);
        if(respuestaUrl.success == true){
          if (respuestaUrl.data.out_EditURL!=null) {
            this.urlTableau = respuestaUrl.data.out_EditURL;
            this.rutaPagina = respuestaUrl.data.out_EditURL;
            localStorage.setItem('urlWCPIframe',this.urlTableau)
            this.iframe = true;
            this.urlCorrect=true;
            this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlTableau);
            setTimeout(() => {
              // console.log("se dispara form alv");
              $('#RecDatos').submit();
              var scrollElem= document.querySelector('#Principal');
              scrollElem.scrollIntoView();
              Swal.close();
            },1000);
          }else{
            setTimeout(() => {
              // console.log("se dispara form alv");
              $('#RecDatos').submit();
              var scrollElem= document.querySelector('#Principal');
              scrollElem.scrollIntoView();
              Swal.close();
            },1000);
            this.urlCorrect=false;
            this.iframe = true;
            this.textWarning=respuestaUrl.data.out_ResultText;
          }

        }else{
          Swal.close();
        }
      });
    }
  }

regresarIframe(){
  this.iframe=false;
  this.urlTableau="";
  localStorage.removeItem('urlResulIframe');
  localStorage.removeItem('urlWCPIframe');
  localStorage.removeItem('modalAvisoIframe');
  localStorage.removeItem('modalMessageAvisoIframe');
  localStorage.removeItem('tipoIframe');
}

copyMessage(){
  let texto = 'CIERRE.CIERRE.COPYLINK';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });

  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  // selBox.value=val;
  selBox.value=this.rutaPagina;
  console.log(this.rutaPagina);
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  Swal.fire({
    icon: 'success',
    title: texto,

    confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
  });

}
helpVideo(){
let taghelpVideo = `<video src="${DATOS_API.urlAssets}video/${this.idiomaVideo}.mp4" autoplay poster="" style="width:100%;" controlslist="nodownload" controls></video>`;
  Swal.fire({
    html: taghelpVideo,
      allowOutsideClick: false,
    width: '70%'
  })


}
}
